import styled from "styled-components/macro";

import { motion } from "framer-motion";

import ListItem from "./ListItem";

export default function UserGivingTransactionsList({ transactions = [] }) {
  const animationVariants = {
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
    hidden: {},
  };

  return (
    <Wrapper>
      <List initial="hidden" animate="visible" variants={animationVariants}>
        {transactions.map((t, index) =>
          index < 5 ? <ListItem key={t.transactionID} {...t} /> : null
        )}
      </List>
    </Wrapper>
  );
}

const Wrapper = styled.div``;

const List = styled(motion.div)`
  padding-top: 4px;
  .mobile & {
    padding-bottom: 10px;
    padding-top: 12px;
  }
`;
